import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Transaction } from 'src/model/transaction.model';

@Component({
    selector: 'app-delete-reason-remark',
    templateUrl: './delete-reason-remark.component.html',
    styleUrls: ['./delete-reason-remark.component.scss'],
    standalone: false
})
export class DeleteReasonRemarkComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private cdr = inject(ChangeDetectorRef);

  deleteRemark: string;
  disabledSubmit = false;

  generalReason: string;
  @Input() deleteTransactionId: number;
  @Input() companyId: number;
  @Input() groupId: number;

  @Input() groupTransactions: Transaction[] = [];
  @Input() transaction: Transaction;
  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.groupId != undefined)
      this.getGroupTransactions(this.groupId)
  }

  calculateTotalPayment() {
    let sum = 0;

    for (let i = 0; i < this.groupTransactions.length; i++) {
      sum += this.groupTransactions[i].Amount;
    }

    return sum;
  }

  submit() {
    if (this.generalReason == undefined || this.generalReason == "")
      this.sharedService.openAlert("Please key in your reason to delete transaction!", ALERT_TYPE.DANGER);
    else {
      //if there's no further desc on reason, then only submit the GENERAL REASON, else append the desc behind GENERAL REASON
      const deleteReason = (this.deleteRemark == undefined || this.deleteRemark == "") ? this.generalReason : this.generalReason + "-" + this.deleteRemark;

      this.passEntry.emit(deleteReason);
      // alert(deleteReason)
    }

    this.activeModal.close();
  }

  getGroupTransactions(groupId: number) {
    const xhttp = this.restApi.getRequest(this.constructApi.getAllTransactionsForTransactionGroup(this.companyId, groupId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const transactionArray = JSON.parse((xhttp.responseText));

        transactionArray.forEach(json => {
          const transaction = new Transaction(json.id, json.remark, json.amount, undefined, json.accountId, json.created_on, json.type, json.handleBy, json.receiptId, json.customerId, undefined, undefined)
          this.groupTransactions.push(transaction);

          this.cdr.detectChanges();
        });
      }
    };
  }

  reset() {
    this.deleteRemark = "";
    this.activeModal.close();
  }
}
